module.exports = __webpack_public_path__ + "static/media/logo.5f40dd18.png";